import { Stack } from '@mui/material';
import {
  FlowDurationUnits,
  type FlowWaitForSignalBlock,
  FlowWaitForSignalBlockSchema,
} from 'flow-schema';
import { upperFirst } from 'lodash';

import { waitForSignalDocumentationMarkdown } from './documentation';
import { BlockSelectField } from '../../ConfigFields/SelectField';
import { BlockTextField } from '../../ConfigFields/TextField';
import { type BlockConfigProps } from '../../types';

const SIGNAL_NAME_HELPER_TEXT = 'Choose external source for signaling.';

const TIMEOUT_VALUE_HELPER_TEXT =
  'Designate amount of time to wait for signal before aborting the flow.';

function FormFields() {
  return (
    <>
      <BlockTextField
        fieldName="config.signalName"
        label="Signal Name"
        required
        helperText={SIGNAL_NAME_HELPER_TEXT}
      />
      <Stack direction="row" width="100%" spacing={1}>
        <BlockTextField
          fieldName="config.timeout.value"
          label="Timeout Value"
          type="number"
          formFieldProps={{
            sx: {
              flex: 1,
            },
          }}
          slotProps={{
            htmlInput: {
              min: 1,
              step: 1,
            },
          }}
          required
          helperText={TIMEOUT_VALUE_HELPER_TEXT}
        />
        <BlockSelectField
          label="Units"
          fieldName="config.timeout.units"
          required
          options={Object.values(FlowDurationUnits).map((unit) => ({
            label: upperFirst(unit),
            value: unit,
          }))}
        />
      </Stack>
    </>
  );
}

export const waitForSignalConfig: BlockConfigProps<FlowWaitForSignalBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'waitForSignal',
  defaultConfig: {
    signalName: 'workflowSignal1',
    timeout: {
      value: 10,
      units: FlowDurationUnits.Minutes,
    },
  },
  configFields: {
    schema: FlowWaitForSignalBlockSchema.shape.config,
    FormFields,
  },
  documentationMarkdown: waitForSignalDocumentationMarkdown,
};
